<template>
  <div class="home"></div>
</template>
<script>
import linkApi from "@/api/apis/link.js";
import newsApi from "@/api/apis/news.js";
import { mapState } from "vuex";
import { addH5Escalate } from "@/utils";
import loginApi from "@/api/apis/login.js";
export default {
  name: "ShareIndex",
  computed: {
    ...mapState("app", ["CONTENT_TYPE", "PAGE"]),
  },
  data() {
    return {};
  },
  methods: {
    /* 根据不同的参数，跳转指定的分享页 */
    toDetailByParams(previewParams) {
      let query = previewParams || this.$route.query;
      if (query.infoKey && !previewParams) {
        this.getRealId(query);
      } else {
        let CONTENT_TYPE = this.CONTENT_TYPE;
        let PAGE = this.PAGE;

        if (Object.prototype.hasOwnProperty.call(query, "contentType")) {
          var contentType = Number(query.contentType);
          if (isNaN(contentType)) contentType = query.contentType;
          let type = !!query.type ? query.type : null;
          switch (contentType) {
            /** 活动详情 **/
            case CONTENT_TYPE.ACTIVITY:
              this.$router.replace({
                path: PAGE.ACTIVITY,
                query: query,
              });
              break;
            /** 活动签到 **/
            case CONTENT_TYPE.ACTIVITY_SIGN:
              this.$router.replace({
                path: PAGE.ACTIVITY_SIGN,
                query: query,
              });
              break;
            /** 作品详情 **/
            case CONTENT_TYPE.ACTIVITY_WORK_DETAIL:
              this.$router.replace({
                path: PAGE.ACTIVITY_WORK_DETAIL,
                query: query,
              });
              break;
            /** 抽奖详情 **/
            case CONTENT_TYPE.RAFFLE:
              this.$router.replace({
                path: PAGE.RAFFLE,
                query: query,
              });
              break;
            /** 投票详情 **/
            case CONTENT_TYPE.VOTE:
              this.$router.replace({
                path: PAGE.VOTE,
                query: query,
              });
              break;
            /** 直播详情 **/
            case CONTENT_TYPE.LIVE:
              this.$router.replace({
                path: PAGE.LIVE,
                query: query,
              });
              break;
            /** 图文详情 **/
            case CONTENT_TYPE.NEWS:
              this.$router.replace({
                path: PAGE.NEWS,
                query: query,
              });
              break;
            /** 图集详情 **/
            case CONTENT_TYPE.GALLERY:
              this.$router.replace({
                path: PAGE.GALLERY,
                query: query,
              });
              break;
            /** 专题 **/
            case CONTENT_TYPE.SPECIAL:
              this.$router.replace({
                path: PAGE.SPECIAL,
                query: query,
              });
              break;
            /** 视频、短视频详情 **/
            case CONTENT_TYPE.VIDEO:
              // 短视频 type=1  ，长视频=2(没有默认长视频)
              if (!!type && type == 1) {
                this.$router.replace({
                  path: PAGE.SHORTVIDEO,
                  query: query,
                });
              } else {
                this.$router.replace({
                  path: PAGE.VIDEO,
                  query: query,
                });
              }
              break;
            /** 问卷调查详情 **/
            case CONTENT_TYPE.QUESTIONNAIRE:
              // 答题 type=1, type=2 其他
              if (!!type && type == 1) {
                this.$router.replace({
                  path: PAGE.ANSWER,
                  query: query,
                });
              } else {
                this.$router.replace({
                  path: PAGE.QUESTIONNAIRE,
                  query: query,
                });
              }
              break;
            /** 音频详情 **/
            case CONTENT_TYPE.AUDIO:
              this.$router.replace({
                path: PAGE.AUDIO,
                query: query,
              });
              break;
            /** 外链 **/
            case CONTENT_TYPE.LINK:
              let params = {
                contentId: query.contentId,
                fromFlag: query.fromFlag || 0,
                site: "wap",
              };
              linkApi
                .getOuterLinkById(params)
                .then((res) => {
                  if (res.suc == 1) {
                    addH5Escalate()
                      .then((data) => {
                        window.open(res.data.linkUrl, "_self");
                        // window.location.href = res.data.linkUrl;
                      })
                      .catch((err) => {
                        window.open(res.data.linkUrl, "_self");
                      });
                  }
                })
                .catch((err) => {
                  console.log("出错啦……");
                });
              break;
            /** 报料 **/
            case CONTENT_TYPE.REPORT:
              this.$router.replace({
                path: PAGE.REPORT,
                query: query,
              });
              break;
            /** 报料列表 **/
            case CONTENT_TYPE.REPORTLIST:
              this.$router.replace({
                path: PAGE.REPORTLIST,
                query: query,
              });
              break;
            /** 问答 **/
            case CONTENT_TYPE.RE_QUESTION:
              this.$router.replace({
                path: PAGE.RE_QUESTION,
                query: query,
              });
              break;
            /** 自媒体 **/
            case CONTENT_TYPE.WE_MEDIA:
              this.$router.replace({
                path: PAGE.WE_MEDIA,
                query: query,
              });
              break;
            /** 邀请 **/
            case CONTENT_TYPE.INVITE:
              this.$router.replace({
                path: PAGE.INVITE,
                query: query,
              });
              break;
            /** 专题分类下内容列表页 **/
            case CONTENT_TYPE.SPECIAL_CONTENT_LIST:
              this.$router.replace({
                path: PAGE.SPECIAL_CONTENT_LIST,
                query: query,
              });
              break;
            /** 专栏 **/
            case CONTENT_TYPE.COLUMN:
              this.$router.replace({
                path: PAGE.COLUMN,
                query: query,
              });
              break;
            /** 占位广告 **/
            case CONTENT_TYPE.AD:
              this.$router.replace({
                path: PAGE.AD,
                query: query,
              });
              break;
            default:
              this.$router.replace({
                path: "/error",
              });
              break;
          }
        } else {
          this.$router.replace({
            path: "/error",
          });
        }
      }
    },
    async getRealId(query) {
      const {infoKey,type,specialType} = query 
      try {
        const res = await newsApi.beforMaterialInfoByKey(
          JSON.stringify({
            infoKey,
          })
        );
        if (res.suc == 1) {
          console.log(res,"===dddd")
          if (res.data.contentType == 7) {
            if (specialType == 2) {
              res.data.contentType = "column";
            }
          }
          let reqParams = {
            infoKey: infoKey,
            contentId: res.data.cid,
            contentType: res.data.contentType,
            type: type,
            deadLineTime:res.data.effectiveDeadlineTime
          }
          if(res.data.contentType == 4 ){
            reqParams.id = res.data.contentId,
            reqParams.cId = res.data.cid
            reqParams.fromFlag = res.data.fromFlag
          }
          if(res.data.contentType == 6){}
          this.toDetailByParams(reqParams);
        } else {
          this.$toast({
            message: res.message || "接口调用出错",
            position: "center",
          });
        }
      } catch (err) {
        this.$toast({
          message: err.message || "接口调用出错",
          position: "center",
        });
      }
    },
  },
  created() {
    this.toDetailByParams();
  },
};
</script>
<style lang="scss" scoped>
.home {
  width: 100%;
  height: 100%;
  padding: 0;
  overflow-x: hidden;
  overflow-y: auto;
}
</style>
